import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, clsx, Heading } from '@a-type/ui';
import { useAppInfo } from '../react.js';
import { AppIcon } from './AppIcon.js';
import cls from './NavLockup.module.css';
export function NavLockup({ showOnMobile }) {
    const app = useAppInfo();
    return (_jsxs(Box, { gap: "sm", layout: "center", p: "sm", className: cls.root, "data-show-on-mobile": showOnMobile, children: [_jsx(AppIcon, { style: { width: 30, height: 30 } }), _jsx(Heading, { render: _jsx("h1", {}), emphasis: "ambient", className: clsx('font-fancy @mode-denser', cls.title), children: app.name })] }));
}
//# sourceMappingURL=NavLockup.js.map